import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api',
  withCredentials: false, // if using token auth; set true if cookies
});

// Ensure session id header present for guest
API.interceptors.request.use((config) => {
  let sessionId = localStorage.getItem('cart_session_id');
  if (!sessionId) {
    sessionId = uuidv4();
    localStorage.setItem('cart_session_id', sessionId);
  }
  config.headers['X-Session-ID'] = sessionId;
  // Optionally attach Authorization bearer token if present
  const token = localStorage.getItem('auth_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
}, error => Promise.reject(error));

export default API;
